import {Component} from "@angular/core";
import {provideEntityModel, provideReportModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {PurchaseOrderEntityModel} from "../purchase-order-entity.model";
import {PurchaseOrderSearchModel} from "../purchase-order-search.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {PurchaseOrderReportModel} from "../../reports/purchase-order-report/purchase-order-report.model";


@Component({
    selector: "wbo-purchase-order-search-page",
    templateUrl: "./purchase-order-search-page.component.html",
    providers: [provideSearchModel(PurchaseOrderSearchModel), provideEntityModel(PurchaseOrderEntityModel), provideReportModel(PurchaseOrderReportModel)]
})
export class PurchaseOrderSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
